import React from "react";
import { MessageChat2 } from "./MessageChat2";

const ExploreIcon = ({ className }) => (
  <svg className={className} width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.49 8.26L14.686 13.671C14.5878 13.9656 14.4224 14.2333 14.2028 14.4528C13.9833 14.6724 13.7156 14.8378 13.421 14.936L8.01 16.74L9.814 11.329C9.91218 11.0344 10.0776 10.7667 10.2972 10.5472C10.5167 10.3276 10.7844 10.1622 11.079 10.064L16.49 8.26Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12.25 22.5C17.7728 22.5 22.25 18.0228 22.25 12.5C22.25 6.97715 17.7728 2.5 12.25 2.5C6.72715 2.5 2.25 6.97715 2.25 12.5C2.25 18.0228 6.72715 22.5 12.25 22.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const HotelIcon = ({ className }) => (
  <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 21V13C15 12.7348 14.8946 12.4805 14.7071 12.2929C14.5196 12.1054 14.2652 12 14 12H10C9.73478 12 9.48043 12.1054 9.29289 12.2929C9.10536 12.4805 9 12.7348 9 13V21M3 10C2.99993 9.7091 3.06333 9.42165 3.18579 9.15775C3.30824 8.89384 3.4868 8.65983 3.709 8.47203L10.709 2.47303C11.07 2.16794 11.5274 2.00055 12 2.00055C12.4726 2.00055 12.93 2.16794 13.291 2.47303L20.291 8.47203C20.5132 8.65983 20.6918 8.89384 20.8142 9.15775C20.9367 9.42165 21.0001 9.7091 21 10V19C21 19.5305 20.7893 20.0392 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0392 3 19.5305 3 19V10Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ConciergeIcon = ({ className }) => <MessageChat2 className={className} />;

const AboutIcon = ({ className }) => (
  <svg className={className} width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 25.6668C20.4433 25.6668 25.6667 20.4435 25.6667 14.0002C25.6667 7.55684 20.4433 2.3335 14 2.3335C7.55668 2.3335 2.33333 7.55684 2.33333 14.0002C2.33333 20.4435 7.55668 25.6668 14 25.6668Z" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14 18.6667V14" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14 9.3335H14.0117" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const BOTTOM_NAV_ICONS = {
  explore: ExploreIcon,
  hotel: HotelIcon,
  concierge: ConciergeIcon,
  about: AboutIcon,
};
